import axios from "axios"
import { URL } from "./settings"

export default class ProlongationService {
    static async getMailingStatuses() {
        try {
            const response = await axios.get(`${URL}/my-students/renewals/additional_data/statuses`, {
                withCredentials: true
            })
            console.log("ProlongationService::getMailingStatuses response", response)
            return response
        } catch (error) {
            console.log(error)
            return error.response
        }
    }

    static async updateMailingStatus(prolongationId, data) {
        try {
            const response = await axios.patch(`${URL}/my-students/renewals/additional_data/${prolongationId}`,
                data,
                { withCredentials: true }
            )
            console.log("ProlongationService::updateMailingStatus response", response)
            return response
        } catch (error) {
            console.log(error)
            return error.response
        }
    }

    static async checkedPurchaseMailing(prolongation_id, is_checked) {
        try {
            const response = await axios.patch(
                `${URL}/my-students/renewals/additional_data/${prolongation_id}/checkbox`,
                { value: is_checked },
                { withCredentials: true }
            )
            console.log("ProlongationService::checkedPurchaseMailing response", response)
            return response
        } catch (error) {
            console.log(error)
            return error.response
        }
    }

    static async updateComment(prolongation_id, comment) {
        try {
            const response = await axios.patch(
                `${URL}/my-students/renewals/additional_data/${prolongation_id}/comment`,
                { comment: comment },
                { withCredentials: true }
            )
            console.log("ProlongationService::updateComment response", response)
            return response
        } catch (error) {
            console.log(error)
            return error.response
        }
    }

    static async updateFinalStatus(prolongation_id, status_id) {
        try {
            const response = await axios.patch(
                `${URL}/my-students/renewals/additional_data/${prolongation_id}/final_status`,
                { status_id: status_id },
                { withCredentials: true }
            )
            console.log("ProlongationService::updateFinalStatus response", response)
            return response
        } catch (error) {
            console.log(error)
            return error.response
        }
    }
}
